<div class="modal-dialog modal-dialog-scrollable m-0 scrollable-dialog">
  <form class="kt-form w-webkit-fill-available" [formGroup]="form">
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">Rebate Setting Details</h5>
            <span class="modal-x-button" (click)="onCloseDialog()">
                <i class="fa fa-times" aria-hidden="true"></i>
            </span>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-md-6 form-group">
                    <label class="control-label">Name <span class="text-danger">*</span></label>
                    <input formControlName="name" type="text" class="col-12 form-control" readonly >
                </div>
                <div class="col-md-6 form-group">
                    <label class="control-label">Minimum Rebate <span class="text-danger">*</span></label>
                    <input formControlName="min_rebate_limit" type="number" (wheel)="false" class="col-12 form-control" readonly >
                </div>
                <div class="col-md-6 form-group">
                    <label class="control-label">Maximum Rebate <span class="text-danger">*</span></label>
                    <input formControlName="max_rebate_limit" type="number" (wheel)="false" class="col-12 form-control" readonly >
                </div>
                <div class="col-md-6 form-group">
                    <label class="control-label">Percentage <span class="text-danger">*</span></label>
                    <input formControlName="percentage" type="number" (wheel)="false" class="col-12 form-control" readonly >
                </div>

            </div>

            <div class="row">
              <div class="col-md-6 form-group">
                <label class="control-label">Currencies <span class="text-danger">*</span></label>
                <kt-dropdown-wo-lazyload
                  [form] = 'form'
                  [dropdownList] = 'dropdown.currencies'
                  [dropdownSettings] = 'dropdownSettings'
                  [formName] = "'currencies'"
                  [selectionAttributes] = "'id'"
                  [selectedItems] = 'currenciesSelectedItems'
                  (selectedItemsChanged)="currenciesSelectedItems = $event">
                </kt-dropdown-wo-lazyload>
              </div>

              <div class="col-md-6 form-group">
                <label class="control-label">Categories <span class="text-danger">*</span></label>
                <kt-dropdown-wo-lazyload
                  [form] = 'form'
                  [dropdownList] = 'categoriesDropdownList'
                  [dropdownSettings] = 'dropdownSettings'
                  [formName] = "'categories'"
                  [selectionAttributes] = "'id'"
                  [selectedItems] = 'categoriesSelectedItems'
                  (selectedItemsChanged)="getSelectedCategories($event)">
                </kt-dropdown-wo-lazyload>
              </div>

              <div class="col-md-6 form-group">
                <label class="control-label">Game Providers <span class="text-danger">*</span></label>
                <ng-container *ngIf="!gameProvidersDropdownLoading; else elseTemplate">
                  <kt-dropdown-wo-lazyload
                    [form] = 'form'
                    [dropdownList] = 'gameProvidersDropdownList'
                    [dropdownSettings] = 'gameProviderDropdownSettings'
                    [formName] = "'game_providers'"
                    [selectionAttributes] = "'id'"
                    [selectedItems] = 'gameProvidersSelectedItems'
                    (selectedItemsChanged)="gameProvidersSelectedItems = $event">
                  </kt-dropdown-wo-lazyload>
                </ng-container>
                <ng-template #elseTemplate>
                  <label class="control-label"><i class="fas fa-circle-notch fa-spin p-0 mr-2"></i></label>
                  <kt-dropdown-wo-lazyload
                    [form] = 'form'
                    [dropdownList] = '[]'
                    [dropdownSettings] = 'gameProviderDropdownSettings'
                    [formName] = "'game_providers'"
                    [selectionAttributes] = "'id'"
                    [selectedItems] = 'gameProvidersSelectedItems'
                    (selectedItemsChanged)="gameProvidersSelectedItems = $event">
                  </kt-dropdown-wo-lazyload>
                </ng-template>

            </div>

              <div class="col-md-6 form-group">
                  <label class="control-label">Member Groups <span class="text-danger">*</span></label>
                  <kt-dropdown-wo-lazyload
                    [form] = 'form'
                    [dropdownList] = 'memberGroupsDropdownList'
                    [dropdownSettings] = 'dropdownSettings'
                    [formName] = "'member_groups'"
                    [selectionAttributes] = "'id'"
                    [selectedItems] = 'memberGroupsSelectedItems'
                    (selectedItemsChanged)="memberGroupsSelectedItems = $event">
                  </kt-dropdown-wo-lazyload>
              </div>

          </div>
            <div class="row" *ngIf="blacklistedGameProvidersData && blacklistedGameProvidersData.length > 0">
              <h5 class="modal-title col-12">Game Provider Blacklist</h5>
              <div class="kt-section col-12">
                <div class="kt-section__content">
                  <div class="table-responsive col-12">
                    <!-- Table -->
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th class="col-4">Game Provider</th>
                          <th class="col-8">Sub Category</th>
                        </tr>
                      </thead>
                      <tbody *ngIf="blacklistedGameProvidersData as rows">
                        <tr *ngFor="let row of rows">
                          <td>{{ row.gameProviders_name }}</td>
                          <td>{{ row.sub_category_name }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <div class="modal-footer">
        </div>
    </div>
  </form>
</div>

<kt-swal-alert [message]="messages$ | async" (confirmed)="onCloseDialog($event)"></kt-swal-alert>
